import { ProgressDotsProps } from "./progress-dots-types";
import { ProgressDot, ProgressDotsContainer } from "./style-component"

const ProgressDots = <T,>({items, currentItemIndex, onDotClick}: ProgressDotsProps<T>) => {
  return (
    <ProgressDotsContainer>
      {items.map((_, index) => (
        <ProgressDot
          $isActive={index === currentItemIndex}
          data-testid={`progress-dot-${index}`}
          className={index === currentItemIndex ? 'active' : ''} 
          key={`item${index}`}
          onClick={() => onDotClick?.(index)}
          style={{ cursor: onDotClick ? 'pointer' : 'default' }}
        />
      ))}
    </ProgressDotsContainer>
  )
}

export default ProgressDots;